import { motion } from "framer-motion";

const paths = {
  star: "M50 6 L61 39 L94 39 L67 59 L77 92 L50 72 L23 92 L33 59 L6 39 L39 39 Z",
  flower:
    "M50 50 m-14 0 a14 14 0 1 0 28 0 a14 14 0 1 0 -28 0 M50 12 a16 16 0 0 1 0 26 M50 88 a16 16 0 0 1 0 -26 M12 50 a16 16 0 0 1 26 0 M88 50 a16 16 0 0 1 -26 0 M21 21 a16 16 0 0 1 19 19 M79 79 a16 16 0 0 1 -19 -19 M79 21 a16 16 0 0 1 -19 19 M21 79 a16 16 0 0 1 19 -19",
  blob: "M50 8 C75 8 92 26 92 50 C92 74 74 92 50 92 C26 92 8 74 8 50 C8 26 25 8 50 8 Z",
  cup: "M28 36 h40 v28 a20 20 0 0 1 -40 0 Z M68 42 h8 a9 9 0 0 1 0 18 h-8 M36 26 c0 -6 5 -6 5 -12 M50 26 c0 -6 5 -6 5 -12 M64 26 c0 -6 5 -6 5 -12",
  book: "M18 24 h26 a8 8 0 0 1 8 8 v44 a8 8 0 0 0 -8 -8 h-26 Z M82 24 h-26 a8 8 0 0 0 -8 8 v44 a8 8 0 0 1 8 -8 h26 Z",
  camera: "M22 34 h14 l5 -8 h18 l5 8 h14 a6 6 0 0 1 6 6 v30 a6 6 0 0 1 -6 6 h-56 a6 6 0 0 1 -6 -6 v-30 a6 6 0 0 1 6 -6 Z M50 44 a13 13 0 1 0 0.1 0",
  cloud: "M30 66 a14 14 0 0 1 4 -27 a18 18 0 0 1 34 -4 a13 13 0 0 1 4 31 Z",
  sphere: "M50 12 a38 38 0 1 0 0.1 0 M50 12 a38 38 0 0 1 0 76 M22 36 h56 M22 64 h56",
};

export const Shape3D = ({
  shape = "star",
  size = 56,
  blue = false,
  filled = true,
  float = true,
  duration = 6,
  delay = 0,
  mouse = false,
  rotateAmp = 10,
  className = "",
  style = {},
}) => {
  const Wrapper = mouse ? motion.div : "div";
  const wrapperProps = mouse
    ? {
        whileHover: { scale: 1.15, rotate: rotateAmp },
        transition: { type: "spring", stiffness: 200, damping: 14 },
      }
    : {};
  return (
    <Wrapper className={`pointer-events-auto select-none ${className}`} style={style} {...wrapperProps}>
      <motion.div
        animate={float ? { y: [0, -11, 0], rotate: [0, rotateAmp * 0.4, 0] } : {}}
        transition={{ repeat: Infinity, duration, delay, ease: "easeInOut" }}
      >
        <svg width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
          {filled && <path d={paths[shape]} fill={blue ? "#5F7FE8" : "#C9DCFA"} opacity={blue ? 0.92 : 0.95} />}
          <path
            d={paths[shape]}
            fill={filled ? "none" : "none"}
            stroke={blue ? "#5F7FE8" : "#332619"}
            strokeWidth="2.4"
            strokeLinejoin="round"
            strokeLinecap="round"
          />
        </svg>
      </motion.div>
    </Wrapper>
  );
};

export const HandNote = ({ children, blue = true, className = "" }) => (
  <span className={`font-hand text-xl md:text-2xl leading-tight ${blue ? "text-cobalt" : "text-cocoa"} ${className}`}>
    {children}
  </span>
);

export const DoodleArrow = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 120 60"
    className={`w-20 md:w-24 text-cobalt ${flip ? "-scale-x-100" : ""} ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M8 12 C 40 6, 78 14, 100 40" />
    <path d="M88 34 L101 42 L90 50" />
  </svg>
);

export const Sticker = ({ children, color = "bg-powder", rotate = "-rotate-3", className = "" }) => (
  <span
    className={`inline-block rounded-full ${color} px-4 py-1.5 text-[11px] tracking-[0.14em] uppercase font-bold text-choco shadow-[0_3px_10px_rgba(51,38,25,0.12)] ${rotate} ${className}`}
  >
    {children}
  </span>
);
